import React, { Component } from 'react';
import { GoogleMap, Marker, withGoogleMap } from 'react-google-maps';
import ServiceProvider from './ServiceProvider';

const MapContainer = withGoogleMap(({ latitude, longitude }) => (latitude && longitude && <GoogleMap
  center={{ lat: latitude, lng: longitude }}
  defaultZoom={12}
><Marker position={{ lat: latitude, lng: longitude }}></Marker></GoogleMap>))

class EmergencyServices extends Component {
  render() {
    const { latitude, longitude } = this.props.hospital;
    const shouldShowMap = !!latitude && !!longitude;
    return (
      <div className="emergencyServices">
        <div className="section-header col">Emergency Services</div>
        <section>
          <div className="row">
            <div className="col">
              <ServiceProvider name="Hospital" location={this.props.hospital} onChange={this.props.onHospitalChange} />
              <hr />
              <ServiceProvider name="Police Station" location={this.props.policeStation} onChange={this.props.onPoliceChange} />
              <hr />
              <ServiceProvider name="Fire Department" location={this.props.fireDepartment} onChange={this.props.onFireDeptChange} />
            </div>
            <div className="col" style={{ minHeight: '200px' }}>
              {shouldShowMap ? <MapContainer
                latitude={latitude}
                longitude={longitude}
                containerElement={<div style={{ height: `185px`, width: '100%' }} />}
                mapElement={<div style={{ height: `100%` }} />}
              /> : <div style={{ color: "red" }}>Couldn't find a nearby hospital.</div>}
              <div className="cya-text">* All data from the Venue Location and Emergency Services section of  this emergency action plan, including, without limitation, emergency room, police, and fire department locations and contact numbers, are automatically pulled into this emergency action plan from Google maps as a service to you. Go4 does not independently verify their accuracy. To ensure these are correct, we suggest you verify them in advance of this job.</div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default EmergencyServices;